import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useFeature } from '@growthbook/growthbook-react';
import useRequestConfig from './useRequestConfig';
import { getAPI } from '../../services/API';
import { isDebugModeSelector } from '../../redux/reducers/app/initialization';
import { FEATURES } from '../../constants/featureToggling';
import { DEFAULT_QUERY_PARAMS } from './constants';
import { sdkErrorHandler } from '../../utils';

export const QUERY_KEY_THEME = 'theme';
export const QUERY_KEY_THEMES = 'themes';

export const useQueryThemes = (query = {}, queryOptions = {}) => {
  const isEnabledThemes = useFeature(FEATURES.USE_THEMES).on;

  const requestConfig = useRequestConfig();
  const isDebugMode = useSelector(isDebugModeSelector);

  const queryParams = {
    status: isDebugMode ? 'ACTIVE,DEBUG' : 'ACTIVE',
    ...DEFAULT_QUERY_PARAMS,
    ...query,
  };

  const fetch = ({ signal }) =>
    getAPI()
      .themes.getAll({ signal, query: queryParams, ...requestConfig })
      .catch(
        sdkErrorHandler({
          ...requestConfig,
          queryOptions,
          query: queryParams,
          source: `SDK API themes.getAll`,
        })
      );

  return useQuery(
    [QUERY_KEY_THEMES, queryParams, requestConfig.headers],
    fetch,
    {
      ...queryOptions,
      enabled: isEnabledThemes && queryOptions?.enabled,
    }
  );
};

export const useQueryTheme = (themeId, queryOptions = {}) => {
  const requestConfig = useRequestConfig();

  const fetch = ({ signal }) =>
    getAPI()
      .themes.getOne(themeId, { signal, ...requestConfig })
      .catch(
        sdkErrorHandler({
          ...requestConfig,
          queryOptions,
          themeId,
          source: `SDK API themes.getOne`,
        })
      );

  return useQuery(
    [QUERY_KEY_THEME, themeId, requestConfig.headers],
    fetch,
    queryOptions
  );
};
